function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _regeneratorValues(e) {
  if (null != e) {
    var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"],
      r = 0;
    if (t) return t.call(e);
    if ("function" == typeof e.next) return e;
    if (!isNaN(e.length)) return {
      next: function next() {
        return e && r >= e.length && (e = void 0), {
          value: e && e[r++],
          done: !e
        };
      }
    };
  }
  throw new TypeError(_typeof(e) + " is not iterable");
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var ModTemplate = require('./../../lib/templates/modtemplate');
var MigrationMain = require('./lib/main');
var ApeBondMain = require('./lib/apebond/main');
var SaitoHeader = require('../../lib/saito/ui/saito-header/saito-header');
var Transaction = require('../../lib/saito/transaction')["default"];
var PeerService = require('saito-js/lib/peer_service')["default"];
var MIGRATION_TEST_DOMAINS = new Set(['localhost', '127.0.0.1', 'ksaito.saito.io', 'ksaito.hda0.net']);
var AUTO_MIGRATION_OPTIONAL_COLUMNS = {
  announcement_hash: "TEXT DEFAULT ''",
  migration_type: "TEXT DEFAULT 'standard'",
  email: "TEXT DEFAULT ''",
  issuance_tx: "TEXT DEFAULT ''",
  issuance_at: "INTEGER DEFAULT 0"
};
function autoMigrationTableSql() {
  var table_name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'auto_migration';
  return "CREATE TABLE IF NOT EXISTS \"".concat(table_name, "\" (\n    id INTEGER PRIMARY KEY AUTOINCREMENT,\n    public_key TEXT DEFAULT '',\n    ticker TEXT DEFAULT '',\n    mixin TEXT DEFAULT '',\n    nolan_received INTEGER DEFAULT 0,\n    created_at INTEGER DEFAULT 0,\n    status TEXT DEFAULT 'pending'\n      CHECK (status IN ('awaiting_mixin','pending','issuing','succeeded','failed')),\n    tx_sig TEXT DEFAULT '',\n    issuance_tx TEXT DEFAULT '',\n    issuance_at INTEGER DEFAULT 0,\n    blk_id INTEGER DEFAULT 0,\n    issued_at INTEGER DEFAULT 0,\n    announcement_hash TEXT DEFAULT '',\n    migration_type TEXT DEFAULT 'standard',\n    email TEXT DEFAULT ''\n  )");
}
var Migration = /*#__PURE__*/function (_ModTemplate) {
  function Migration(app) {
    var _this;
    _classCallCheck(this, Migration);
    _this = _callSuper(this, Migration, [app]);
    _this.app = app;
    _this.name = 'Migration';
    _this.slug = 'migration';
    _this.description = 'Migrate ERC20 or BEP20 tokens to Saito Native Tokens';
    _this.categories = 'Core Utilities Messaging';
    _this.status = 'prod';
    _this["class"] = 'utility';
    _this.styles = ['/migration/style.css'];
    _this.dependencies = ['Relay', 'Mixin', 'ERC', 'BEP', 'MailRelay'];
    _this.main = null;
    _this.header = null;
    _this.key_cache = {}; // Mapping from Mixin Address --> Saito publicKey
    _this.pending_payments = [];
    _this.payment_cache = {};
    _this.processing_payments = false;

    // A crypto-payment announcement can reach us just before Mixin exposes the
    // corresponding Safe snapshot. It can also be restored during startup
    // before Mixin has installed its dynamic wrapped-SAITO module. Retry the exact
    // transaction-hash lookup in both cases instead of relying solely on the
    // module's incremental history cursor.
    _this.mixin_reconciliation_timers = {};
    _this.mixin_reconciliation_attempts = {};
    _this.mixin_reconciliation_delays = [2000, 5000, 15000, 45000, 90000, 120000, 180000];
    _this.wrapped_saito_tickers = ['ERC-SAITO', 'BEP-SAITO'];
    _this.wrapped_saito_ticker = 'ERC-SAITO';
    _this.MAX_DEPOSIT = 1000000; // Max of 1 million at a time

    _this.relay_available = false;
    _this.can_auto = false;
    _this.auto_migration_error = '';
    _this.wrappedSaitoMod = null;
    _this.wrappedSaitoMods = {};

    //this.migration_publickey = 'zYCCXRZt2DyPD9UmxRfwFgLTNAqCd5VE8RuNneg4aNMK';
    _this.migration_publickey = 'cNACSaLdZQfbPkTTud4ezLWFYqRPUCMEt2dgLxJ9Axxx';
    _this.migration_mixin_address = '';
    _this.apebond = new ApeBondMain(_this.app, _this);
    return _possibleConstructorReturn(_this, _this);
  }
  _inherits(Migration, _ModTemplate);
  return _createClass(Migration, [{
    key: "isMigrationTestDomain",
    value: function isMigrationTestDomain() {
      var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var normalized_host = String(host).toLowerCase().replace(/\.$/, '');
      return MIGRATION_TEST_DOMAINS.has(normalized_host);
    }
  }, {
    key: "returnMigrationHost",
    value: function returnMigrationHost() {
      var _this$app$options;
      if (this.app.BROWSER && typeof window !== 'undefined') {
        return window.location.hostname;
      }
      return ((_this$app$options = this.app.options) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.server) === null || _this$app$options === void 0 || (_this$app$options = _this$app$options.endpoint) === null || _this$app$options === void 0 ? void 0 : _this$app$options.host) || '';
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this2 = this;
        var migration_host;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Migration, "initialize", this, 3)([app]);
            case 1:
              migration_host = this.returnMigrationHost();
              if (this.app.BROWSER) {
                _context.n = 5;
                break;
              }
              if (this.isMigrationTestDomain(migration_host)) {
                this.migration_publickey = this.publicKey;
                console.warn('---> using this node as the migration bot for testing');
              }
              if (!(this.publicKey === this.migration_publickey)) {
                _context.n = 4;
                break;
              }
              _context.n = 2;
              return this.ensureAutoMigrationSchema();
            case 2:
              _context.n = 3;
              return this.load();
            case 3:
              // Wrapped SAITO inbound confirmed via CryptoModule receivePayment polling
              this.app.connection.on('on-receive-expected-payment', function (hash, details) {
                // Secondary stricter checks
                if (!_this2.isWrappedSaitoTicker(details.ticker)) {
                  return;
                }
                if (details.transaction_signature !== hash) {
                  console.warn('not our expected payment');
                  return;
                }
                _this2.confirmMixinInbound(hash, details.ticker);
              });
            case 4:
              return _context.a(2);
            case 5:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "ensureAutoMigrationSchema",
    value: function () {
      var _ensureAutoMigrationSchema = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var db, columns, column_names, required_columns, missing_required_columns, _i, _Object$entries, _Object$entries$_i, column_name, definition, table, transaction_started, reason, _t, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return this.app.storage.returnDatabaseByName('migration');
            case 1:
              db = _context2.v;
              _context2.n = 2;
              return db.run(autoMigrationTableSql());
            case 2:
              _context2.n = 3;
              return db.all('PRAGMA table_info(auto_migration)');
            case 3:
              columns = _context2.v;
              column_names = new Set(columns.map(function (column) {
                return column.name;
              }));
              required_columns = ['id', 'public_key', 'ticker', 'mixin', 'nolan_received', 'created_at', 'status', 'tx_sig', 'blk_id', 'issued_at'];
              missing_required_columns = required_columns.filter(function (column_name) {
                return !column_names.has(column_name);
              });
              if (!missing_required_columns.length) {
                _context2.n = 4;
                break;
              }
              throw new Error("Migration database has an unsupported auto_migration schema; missing: ".concat(missing_required_columns.join(', ')));
            case 4:
              _i = 0, _Object$entries = Object.entries(AUTO_MIGRATION_OPTIONAL_COLUMNS);
            case 5:
              if (!(_i < _Object$entries.length)) {
                _context2.n = 8;
                break;
              }
              _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2), column_name = _Object$entries$_i[0], definition = _Object$entries$_i[1];
              if (column_names.has(column_name)) {
                _context2.n = 7;
                break;
              }
              _context2.n = 6;
              return db.run("ALTER TABLE auto_migration ADD COLUMN ".concat(column_name, " ").concat(definition));
            case 6:
              column_names.add(column_name);
            case 7:
              _i++;
              _context2.n = 5;
              break;
            case 8:
              _context2.n = 9;
              return db.get("SELECT sql FROM sqlite_master WHERE type = 'table' AND name = 'auto_migration'");
            case 9:
              table = _context2.v;
              if (table !== null && table !== void 0 && table.sql) {
                _context2.n = 10;
                break;
              }
              throw new Error('Migration database is missing the auto_migration table definition');
            case 10:
              if (table.sql.includes('awaiting_mixin')) {
                _context2.n = 24;
                break;
              }
              transaction_started = false;
              _context2.p = 11;
              _context2.n = 12;
              return db.exec('BEGIN IMMEDIATE');
            case 12:
              transaction_started = true;
              _context2.n = 13;
              return db.exec('DROP TABLE IF EXISTS auto_migration_upgrade');
            case 13:
              _context2.n = 14;
              return db.run(autoMigrationTableSql('auto_migration_upgrade'));
            case 14:
              _context2.n = 15;
              return db.run("INSERT INTO auto_migration_upgrade (\n          id, public_key, ticker, mixin, nolan_received, created_at, status,\n          tx_sig, issuance_tx, issuance_at, blk_id, issued_at,\n          announcement_hash, migration_type, email\n        ) SELECT\n          id, public_key, ticker, mixin, nolan_received, created_at, status,\n          tx_sig, issuance_tx, issuance_at, blk_id, issued_at,\n          announcement_hash, migration_type, email\n        FROM auto_migration");
            case 15:
              _context2.n = 16;
              return db.exec('DROP TABLE auto_migration');
            case 16:
              _context2.n = 17;
              return db.exec('ALTER TABLE auto_migration_upgrade RENAME TO auto_migration');
            case 17:
              _context2.n = 18;
              return db.exec('COMMIT');
            case 18:
              _context2.n = 24;
              break;
            case 19:
              _context2.p = 19;
              _t = _context2.v;
              if (!transaction_started) {
                _context2.n = 23;
                break;
              }
              _context2.p = 20;
              _context2.n = 21;
              return db.exec('ROLLBACK');
            case 21:
              _context2.n = 23;
              break;
            case 22:
              _context2.p = 22;
              _t2 = _context2.v;
            case 23:
              reason = (_t === null || _t === void 0 ? void 0 : _t.message) || String(_t);
              throw new Error("Migration database schema upgrade failed: ".concat(reason));
            case 24:
              return _context2.a(2);
          }
        }, _callee2, this, [[20, 22], [11, 19]]);
      }));
      function ensureAutoMigrationSchema() {
        return _ensureAutoMigrationSchema.apply(this, arguments);
      }
      return ensureAutoMigrationSchema;
    }()
    /**
     * Format and send email for record keeping
     * data aka txmsg { module, amount, to, from }
     */
  }, {
    key: "findAutoMigrationByAnnouncementHash",
    value: function () {
      var _findAutoMigrationByAnnouncementHash = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(announcement_hash) {
        var sql, rows;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (announcement_hash) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2, null);
            case 1:
              sql = "SELECT * FROM auto_migration WHERE announcement_hash = $announcement_hash LIMIT 1";
              _context3.n = 2;
              return this.app.storage.queryDatabase(sql, {
                $announcement_hash: announcement_hash
              }, 'migration');
            case 2:
              rows = _context3.v;
              return _context3.a(2, rows !== null && rows !== void 0 && rows.length ? rows[0] : null);
          }
        }, _callee3, this);
      }));
      function findAutoMigrationByAnnouncementHash(_x2) {
        return _findAutoMigrationByAnnouncementHash.apply(this, arguments);
      }
      return findAutoMigrationByAnnouncementHash;
    }()
  }, {
    key: "isWrappedSaitoTicker",
    value: function isWrappedSaitoTicker() {
      var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      return (this.wrapped_saito_tickers || ['ERC-SAITO', 'BEP-SAITO']).includes(ticker);
    }
  }, {
    key: "returnWrappedSaitoLabel",
    value: function returnWrappedSaitoLabel() {
      var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.wrapped_saito_ticker;
      return ticker === 'BEP-SAITO' ? 'BEP20 SAITO' : 'ERC20 SAITO';
    }
  }, {
    key: "selectWrappedSaitoTicker",
    value: function () {
      var _selectWrappedSaitoTicker = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var ticker,
          activate,
          activated,
          _args4 = arguments;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              ticker = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : 'ERC-SAITO';
              activate = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
              if (this.isWrappedSaitoTicker(ticker)) {
                _context4.n = 1;
                break;
              }
              throw new Error("Unsupported wrapped SAITO ticker: ".concat(ticker));
            case 1:
              this.wrapped_saito_ticker = ticker;
              this.wrappedSaitoMod = this.returnWrappedSaitoModule(ticker);
              if (this.wrappedSaitoMod) {
                _context4.n = 2;
                break;
              }
              throw new Error("".concat(ticker, " is not installed"));
            case 2:
              if (!(activate && !this.wrappedSaitoMod.isActivated())) {
                _context4.n = 4;
                break;
              }
              _context4.n = 3;
              return this.wrappedSaitoMod.activate();
            case 3:
              activated = _context4.v;
              if (!(activated === false || !this.wrappedSaitoMod.isActivated())) {
                _context4.n = 4;
                break;
              }
              throw new Error("".concat(ticker, " could not be activated"));
            case 4:
              return _context4.a(2, this.wrappedSaitoMod);
          }
        }, _callee4, this);
      }));
      function selectWrappedSaitoTicker() {
        return _selectWrappedSaitoTicker.apply(this, arguments);
      }
      return selectWrappedSaitoTicker;
    }()
  }, {
    key: "confirmMixinInbound",
    value: function () {
      var _confirmMixinInbound = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(hash) {
        var _this$wrappedSaitoMod;
        var ticker,
          payment,
          crypto_mod,
          _crypto_mod$stopPolli,
          _args5 = arguments,
          _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              ticker = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : '';
              payment = this.payment_cache[hash];
              if (!(!payment || payment.status !== 'awaiting_mixin')) {
                _context5.n = 1;
                break;
              }
              console.warn("Inbound Mixin doesn't match expected payment...");
              console.log(this.payment_cache);
              return _context5.a(2);
            case 1:
              if (!(ticker && payment.ticker && payment.ticker !== ticker)) {
                _context5.n = 2;
                break;
              }
              console.warn("Inbound Mixin ticker doesn't match expected payment...");
              return _context5.a(2);
            case 2:
              payment.ticker || (payment.ticker = ticker || this.wrapped_saito_ticker);
              this.clearMixinReconciliation(hash);
              payment.status = 'pending';
              _context5.p = 3;
              _context5.n = 4;
              return this.updatePayment(payment);
            case 4:
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t3 = _context5.v;
              payment.status = 'awaiting_mixin';
              this.scheduleMixinReconciliation(hash);
              throw _t3;
            case 6:
              if (!this.pending_payments.some(function (p) {
                return p.id === payment.id;
              })) {
                this.pending_payments.push(payment);
              }
              crypto_mod = ((_this$wrappedSaitoMod = this.wrappedSaitoMods) === null || _this$wrappedSaitoMod === void 0 ? void 0 : _this$wrappedSaitoMod[payment.ticker]) || (payment.ticker === this.wrapped_saito_ticker ? this.wrappedSaitoMod : null) || this.returnWrappedSaitoModule(payment.ticker);
              if (crypto_mod !== null && crypto_mod !== void 0 && crypto_mod.transfers_inbound) {
                delete crypto_mod.transfers_inbound[hash];
                if (Object.keys(crypto_mod.transfers_inbound).length === 0) {
                  (_crypto_mod$stopPolli = crypto_mod.stopPolling) === null || _crypto_mod$stopPolli === void 0 || _crypto_mod$stopPolli.call(crypto_mod);
                }
              }
              delete this.payment_cache[hash];
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[3, 5]]);
      }));
      function confirmMixinInbound(_x3) {
        return _confirmMixinInbound.apply(this, arguments);
      }
      return confirmMixinInbound;
    }()
  }, {
    key: "clearMixinReconciliation",
    value: function clearMixinReconciliation(hash) {
      var _this$mixin_reconcili;
      var timer = (_this$mixin_reconcili = this.mixin_reconciliation_timers) === null || _this$mixin_reconcili === void 0 ? void 0 : _this$mixin_reconcili[hash];
      if (timer) {
        clearTimeout(timer);
      }
      if (this.mixin_reconciliation_timers) {
        delete this.mixin_reconciliation_timers[hash];
      }
      if (this.mixin_reconciliation_attempts) {
        delete this.mixin_reconciliation_attempts[hash];
      }
    }
  }, {
    key: "returnWrappedSaitoModule",
    value: function returnWrappedSaitoModule() {
      var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.wrapped_saito_ticker;
      if (!this.isWrappedSaitoTicker(ticker)) {
        return null;
      }
      var crypto_mod = this.app.wallet.returnCryptoModuleByTicker(ticker);
      if (crypto_mod) {
        this.wrappedSaitoMods || (this.wrappedSaitoMods = {});
        this.wrappedSaitoMods[ticker] = crypto_mod;
        if (ticker === this.wrapped_saito_ticker) {
          this.wrappedSaitoMod = crypto_mod;
        }
      }
      return crypto_mod;
    }
  }, {
    key: "reconcileMixinInbound",
    value: function () {
      var _reconcileMixinInbound = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(hash) {
        var payment, crypto_mod, amount, confirmed_payment, _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              payment = this.payment_cache[hash];
              if (!(!payment || payment.status !== 'awaiting_mixin')) {
                _context6.n = 1;
                break;
              }
              this.clearMixinReconciliation(hash);
              return _context6.a(2, true);
            case 1:
              crypto_mod = this.returnWrappedSaitoModule(payment.ticker || this.wrapped_saito_ticker);
              if (!(typeof (crypto_mod === null || crypto_mod === void 0 ? void 0 : crypto_mod.findInboundPaymentBySignature) !== 'function')) {
                _context6.n = 2;
                break;
              }
              return _context6.a(2, false);
            case 2:
              amount = this.app.wallet.convertNolanToSaito(payment.nolan_received);
              _context6.p = 3;
              _context6.n = 4;
              return crypto_mod.findInboundPaymentBySignature(hash, amount, payment.mixin, payment.created_at);
            case 4:
              confirmed_payment = _context6.v;
              if (!confirmed_payment) {
                _context6.n = 6;
                break;
              }
              console.info("Migration: reconciled confirmed Mixin deposit ".concat(hash));
              _context6.n = 5;
              return this.confirmMixinInbound(hash);
            case 5:
              return _context6.a(2, true);
            case 6:
              _context6.n = 8;
              break;
            case 7:
              _context6.p = 7;
              _t4 = _context6.v;
              console.error("Migration: unable to reconcile Mixin deposit ".concat(hash), _t4);
            case 8:
              return _context6.a(2, false);
          }
        }, _callee6, this, [[3, 7]]);
      }));
      function reconcileMixinInbound(_x4) {
        return _reconcileMixinInbound.apply(this, arguments);
      }
      return reconcileMixinInbound;
    }()
  }, {
    key: "scheduleMixinReconciliation",
    value: function scheduleMixinReconciliation(hash) {
      var _this$mixin_reconcili2,
        _this3 = this,
        _timer$unref;
      if (!hash || !this.payment_cache[hash] || (_this$mixin_reconcili2 = this.mixin_reconciliation_timers) !== null && _this$mixin_reconcili2 !== void 0 && _this$mixin_reconcili2[hash]) {
        return;
      }
      this.mixin_reconciliation_timers || (this.mixin_reconciliation_timers = {});
      this.mixin_reconciliation_attempts || (this.mixin_reconciliation_attempts = {});
      var attempt = this.mixin_reconciliation_attempts[hash] || 0;
      var delays = this.mixin_reconciliation_delays || [];
      if (attempt >= delays.length) {
        delete this.mixin_reconciliation_attempts[hash];
        console.error("Migration: timed out reconciling Mixin deposit ".concat(hash));
        return;
      }
      this.mixin_reconciliation_attempts[hash] = attempt + 1;
      var timer = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var confirmed;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              delete _this3.mixin_reconciliation_timers[hash];
              _context7.n = 1;
              return _this3.reconcileMixinInbound(hash);
            case 1:
              confirmed = _context7.v;
              if (!confirmed) {
                _this3.scheduleMixinReconciliation(hash);
              }
            case 2:
              return _context7.a(2);
          }
        }, _callee7);
      })), delays[attempt]);

      // Do not keep a server process alive solely for a reconciliation retry.
      timer === null || timer === void 0 || (_timer$unref = timer.unref) === null || _timer$unref === void 0 || _timer$unref.call(timer);
      this.mixin_reconciliation_timers[hash] = timer;
    }
  }, {
    key: "resumeAwaitingMixin",
    value: function () {
      var _resumeAwaitingMixin = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row) {
        var _this$wrappedSaitoMod2;
        var amount, payment, ticker, crypto_mod;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (row !== null && row !== void 0 && row.announcement_hash) {
                _context8.n = 1;
                break;
              }
              return _context8.a(2);
            case 1:
              amount = this.app.wallet.convertNolanToSaito(row.nolan_received);
              payment = _objectSpread(_objectSpread({}, row), {}, {
                nolan_received: BigInt(row.nolan_received || 0)
              });
              this.payment_cache[row.announcement_hash] = payment;
              _context8.n = 2;
              return this.reconcileMixinInbound(row.announcement_hash);
            case 2:
              if (!_context8.v) {
                _context8.n = 3;
                break;
              }
              return _context8.a(2);
            case 3:
              ticker = row.ticker || this.wrapped_saito_ticker;
              crypto_mod = ((_this$wrappedSaitoMod2 = this.wrappedSaitoMods) === null || _this$wrappedSaitoMod2 === void 0 ? void 0 : _this$wrappedSaitoMod2[ticker]) || (ticker === this.wrapped_saito_ticker ? this.wrappedSaitoMod : null);
              if (!crypto_mod) {
                _context8.n = 4;
                break;
              }
              _context8.n = 4;
              return this.app.wallet.receivePayment(ticker, row.mixin, amount, row.announcement_hash);
            case 4:
              this.scheduleMixinReconciliation(row.announcement_hash);
            case 5:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function resumeAwaitingMixin(_x5) {
        return _resumeAwaitingMixin.apply(this, arguments);
      }
      return resumeAwaitingMixin;
    }()
  }, {
    key: "returnServices",
    value: function returnServices() {
      var services = [];
      if (!this.app.BROWSER) {
        if (this.publicKey == this.migration_publickey) {
          services.push(new PeerService(null, 'migration'));
        }
      }
      return services;
    }
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      expressapp.get(['/migration/apebond', '/migration/apebond/'], function (req, res) {
        res.sendFile("".concat(__dirname, "/web/index.html"));
      });
      _superPropGet(Migration, "webServer", this, 3)([app, expressapp, express]);
    }
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(app, peer) {
        var _this4 = this;
        var service,
          _args0 = arguments;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              service = _args0.length > 2 && _args0[2] !== undefined ? _args0[2] : {};
              // Update migration service node address
              if (this.browser_active) {
                if (service.service == 'migration') {
                  if (peer.publicKey === this.migration_publickey || this.isMigrationTestDomain(this.returnMigrationHost())) {
                    this.migration_publickey = peer.publicKey;
                  } else {
                    console.warn('Ignoring an unexpected migration service provider', peer.publicKey);
                  }
                }
                if (service.service == 'relay') {
                  this.relay_available = true;
                }

                //
                // Make sure Mixin is online in case we need to create an account
                //
                if (service.service === 'mixin') {
                  setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
                    var crypto_mod, _this4$main, _this4$main2, _t5;
                    return _regenerator().w(function (_context9) {
                      while (1) switch (_context9.p = _context9.n) {
                        case 0:
                          _context9.p = 0;
                          _context9.n = 1;
                          return _this4.selectWrappedSaitoTicker(_this4.wrapped_saito_ticker, true);
                        case 1:
                          crypto_mod = _context9.v;
                          if (!crypto_mod) {
                            _context9.n = 3;
                            break;
                          }
                          if (!(_this4.relay_available && crypto_mod.address)) {
                            _context9.n = 2;
                            break;
                          }
                          _this4.sendMigrationPingTransaction({
                            ticker: _this4.wrapped_saito_ticker,
                            mixin_address: crypto_mod.formatAddress()
                          });
                          siteMessage('checking if automated migration available...', 2000);
                          return _context9.a(2);
                        case 2:
                          _context9.n = 4;
                          break;
                        case 3:
                          _this4.auto_migration_error = 'Automated Migration requires Mixin and wrapped SAITO modules to be installed.';
                          (_this4$main = _this4.main) === null || _this4$main === void 0 || _this4$main.render();
                          salert('Automated Migration requires Mixin and wrapped SAITO modules to be installed!');
                        case 4:
                          _context9.n = 6;
                          break;
                        case 5:
                          _context9.p = 5;
                          _t5 = _context9.v;
                          console.error(_t5);
                          _this4.auto_migration_error = 'Unable to initialize the deposit address for automated migration.';
                          (_this4$main2 = _this4.main) === null || _this4$main2 === void 0 || _this4$main2.render();
                          salert('Unable to initialize deposit address for automated migration');
                        case 6:
                          return _context9.a(2);
                      }
                    }, _callee9, null, [[0, 5]]);
                  })), 1000);
                }
              }
            case 1:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function onPeerServiceUp(_x6, _x7) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1() {
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              this.main = this.apebond.isActive() ? this.apebond : new MigrationMain(this.app, this);
              this.header = new SaitoHeader(this.app, this);
              _context1.n = 1;
              return this.header.initialize(this.app);
            case 1:
              this.addComponent(this.main);
              this.addComponent(this.header);
              _context1.n = 2;
              return _superPropGet(Migration, "render", this, 3)([this.app, this]);
            case 2:
              // Set this on rendering... All modules will be initialized, so guaranteed to return if available.
              try {
                this.wrappedSaitoMod = this.returnWrappedSaitoModule();
              } catch (err) {
                console.error(err);
              }
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "shouldAffixCallbackToModule",
    value: function shouldAffixCallbackToModule(modname) {
      if (modname == this.name) {
        return 1;
      }

      // Monitor wrapped SAITO transactions only.
      var _iterator = _createForOfIteratorHelper(this.wrapped_saito_tickers || []),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var ticker = _step.value;
          try {
            var _this$returnWrappedSa;
            if (((_this$returnWrappedSa = this.returnWrappedSaitoModule(ticker)) === null || _this$returnWrappedSa === void 0 ? void 0 : _this$returnWrappedSa.name) == modname) {
              return 1;
            }
          } catch (err) {
            // Crypto modules may not be installed yet during callback registration.
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return 0;
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _args10 = arguments;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              tx = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : null;
              peer = _args10.length > 2 ? _args10[2] : undefined;
              mycallback = _args10.length > 3 ? _args10[3] : undefined;
              if (!(tx !== null && tx !== void 0 && tx.isTo(this.publicKey))) {
                _context10.n = 3;
                break;
              }
              txmsg = tx.returnMessage();
              if (!(txmsg.request == 'migration accept')) {
                _context10.n = 1;
                break;
              }
              _context10.n = 1;
              return this.receiveMigrationResponseTransaction(app, tx, peer, mycallback);
            case 1:
              if (!(txmsg.request == 'migration check')) {
                _context10.n = 2;
                break;
              }
              _context10.n = 2;
              return this.receiveMigrationPingTransaction(tx);
            case 2:
              if (txmsg.request == 'migration failure') {
                if (this.app.BROWSER) {
                  salert('Uh oh, something went wrong with the automated migration. Please back up your wallet to ensure the security of your tokens and contact the team for a manual resolution.');
                }
              }
            case 3:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function handlePeerTransaction(_x8) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "onConfirmation",
    value: function () {
      var _onConfirmation = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(blk, tx, conf) {
        var txmsg;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (!(this.app.BROWSER && !tx.isTo(this.publicKey))) {
                _context11.n = 1;
                break;
              }
              return _context11.a(2);
            case 1:
              if (!this.hasSeenTransaction(tx, blk)) {
                _context11.n = 2;
                break;
              }
              console.error('Migration is ignoring a duplicate transaction!!!!');
              return _context11.a(2);
            case 2:
              _context11.n = 3;
              return tx.decryptMessage(this.app);
            case 3:
              txmsg = tx.returnMessage();
              if (!(Number(conf) == 0)) {
                _context11.n = 6;
                break;
              }
              if (!(txmsg.request === 'save migration data')) {
                _context11.n = 4;
                break;
              }
              _context11.n = 4;
              return this.receiveStoreMigrationTransaction(blk, tx, conf);
            case 4:
              if (txmsg.request == 'migration check') {
                this.receiveMigrationPingTransaction(tx);
              }
              if (txmsg.request == 'migration issuance') {
                if (!this.app.BROWSER) {
                  this.receiveMigrationIssuanceTransaction(tx, blk);
                }
              }
              if (!(txmsg.request === 'crypto payment')) {
                _context11.n = 6;
                break;
              }
              if (!this.app.BROWSER) {
                _context11.n = 5;
                break;
              }
              return _context11.a(2);
            case 5:
              _context11.n = 6;
              return this.receiveCryptoPaymentTransaction(tx, blk);
            case 6:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function onConfirmation(_x9, _x0, _x1) {
        return _onConfirmation.apply(this, arguments);
      }
      return onConfirmation;
    }()
    /**
     *  Send transaction for manual migration
     */
  }, {
    key: "sendStoreMigrationTransaction",
    value: function () {
      var _sendStoreMigrationTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(app, mod, data) {
        var obj, key, newtx;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              obj = {
                module: this.name,
                request: 'save migration data',
                data: {}
              };
              for (key in data) {
                obj.data[key] = data[key];
              }
              _context12.n = 1;
              return this.app.wallet.createUnsignedTransaction();
            case 1:
              newtx = _context12.v;
              newtx.msg = obj;
              _context12.n = 2;
              return newtx.sign();
            case 2:
              _context12.n = 3;
              return this.app.network.propagateTransaction(newtx);
            case 3:
              return _context12.a(2, newtx);
          }
        }, _callee12, this);
      }));
      function sendStoreMigrationTransaction(_x10, _x11, _x12) {
        return _sendStoreMigrationTransaction.apply(this, arguments);
      }
      return sendStoreMigrationTransaction;
    }()
    /**
     *  Send transaction for manual migration
     */
  }, {
    key: "receiveStoreMigrationTransaction",
    value: function () {
      var _receiveStoreMigrationTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(blk, tx, conf) {
        var txmsg, sql, params, _t6;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.p = _context13.n) {
            case 0:
              _context13.p = 0;
              if (!(this.app.BROWSER == 1)) {
                _context13.n = 1;
                break;
              }
              return _context13.a(2);
            case 1:
              //
              // servers
              //
              txmsg = tx.returnMessage();
              sql = "INSERT INTO migration ( \n                  publickey,\n                  erc20,\n                  erc20_tx_id,\n                  email,\n                  saito_isssued,\n                  created_at\n                 )\n                 VALUES ( \n                  $publickey,\n                  $erc20,\n                  '',\n                  $email,\n                  0,\n                  $created_at\n                 )";
              params = {
                $publickey: txmsg.data.pk,
                $erc20: txmsg.data.erc20,
                $email: txmsg.data.email,
                $created_at: tx.timestamp
              };
              _context13.n = 2;
              return this.app.storage.runDatabase(sql, params, 'migration');
            case 2:
              _context13.n = 4;
              break;
            case 3:
              _context13.p = 3;
              _t6 = _context13.v;
              console.error('ERROR in saving migration data to db: ' + _t6);
            case 4:
              return _context13.a(2);
          }
        }, _callee13, this, [[0, 3]]);
      }));
      function receiveStoreMigrationTransaction(_x13, _x14, _x15) {
        return _receiveStoreMigrationTransaction.apply(this, arguments);
      }
      return receiveStoreMigrationTransaction;
    }()
  }, {
    key: "sendFailureNotification",
    value: function () {
      var _sendFailureNotification = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(publickey) {
        var newtx;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _context14.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(publickey);
            case 1:
              newtx = _context14.v;
              newtx.msg = {
                module: this.name,
                request: 'migration failure',
                data: null
              };
              _context14.n = 2;
              return newtx.sign();
            case 2:
              this.app.connection.emit('relay-transaction', newtx);
            case 3:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function sendFailureNotification(_x16) {
        return _sendFailureNotification.apply(this, arguments);
      }
      return sendFailureNotification;
    }()
    /**
     * [BROWSER] Ping the Migration Bot to:
     * -- check its availability
     * -- let it cache my publickey & mixin account number
     * -- get its mixin account number
     *
     * We ping the migration bot twice. The first on-chain ping verifies the wallet
     * can propagate transactions and caches mixin↔pubkey. The second relay ping
     * (post-deposit) re-checks that the bot still has sufficient balance.
     */
  }, {
    key: "sendMigrationPingTransaction",
    value: function () {
      var _sendMigrationPingTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(data) {
        var offchain,
          newtx,
          _args15 = arguments;
        return _regenerator().w(function (_context15) {
          while (1) switch (_context15.n) {
            case 0:
              offchain = _args15.length > 1 && _args15[1] !== undefined ? _args15[1] : false;
              if (this.migration_publickey) {
                _context15.n = 1;
                break;
              }
              return _context15.a(2);
            case 1:
              _context15.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.migration_publickey);
            case 2:
              newtx = _context15.v;
              newtx.msg = {
                module: this.name,
                request: 'migration check',
                data: data
              };
              _context15.n = 3;
              return newtx.sign();
            case 3:
              if (!offchain) {
                _context15.n = 4;
                break;
              }
              this.app.connection.emit('relay-transaction', newtx);
              _context15.n = 5;
              break;
            case 4:
              _context15.n = 5;
              return this.app.network.propagateTransaction(newtx);
            case 5:
              return _context15.a(2);
          }
        }, _callee15, this);
      }));
      function sendMigrationPingTransaction(_x17) {
        return _sendMigrationPingTransaction.apply(this, arguments);
      }
      return sendMigrationPingTransaction;
    }()
    /**
     * [SERVER] Migration Bot respond to Ping
     * -- give user transfer details (address, max amount)
     * -- cache user's Saito public key and Mixin account number
     */
  }, {
    key: "receiveMigrationPingTransaction",
    value: function () {
      var _receiveMigrationPingTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16(tx) {
        var _txmsg$data, _txmsg$data2, _txmsg$data3;
        var txmsg, saitozen, ticker, crypto_mod, error, activated, is_apebond, newtx, max_deposit, mixin_address, _t7;
        return _regenerator().w(function (_context16) {
          while (1) switch (_context16.p = _context16.n) {
            case 0:
              txmsg = tx.returnMessage();
              saitozen = tx.from[0].publicKey;
              ticker = (txmsg === null || txmsg === void 0 || (_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.ticker) || 'ERC-SAITO';
              crypto_mod = null;
              error = null; // Only respond if I am the known migration bot
              if (!(this.app.BROWSER || this.publicKey !== this.migration_publickey)) {
                _context16.n = 1;
                break;
              }
              return _context16.a(2);
            case 1:
              if (this.isWrappedSaitoTicker(ticker)) {
                _context16.n = 2;
                break;
              }
              error = "Unsupported wrapped SAITO ticker: ".concat(ticker);
              _context16.n = 7;
              break;
            case 2:
              _context16.p = 2;
              crypto_mod = this.returnWrappedSaitoModule(ticker);
              if (crypto_mod) {
                _context16.n = 3;
                break;
              }
              throw new Error("".concat(ticker, " is not installed"));
            case 3:
              if (crypto_mod.isActivated()) {
                _context16.n = 5;
                break;
              }
              _context16.n = 4;
              return crypto_mod.activate();
            case 4:
              activated = _context16.v;
              if (!(activated === false || !crypto_mod.isActivated())) {
                _context16.n = 5;
                break;
              }
              throw new Error("".concat(ticker, " could not be activated"));
            case 5:
              _context16.n = 7;
              break;
            case 6:
              _context16.p = 6;
              _t7 = _context16.v;
              error = (_t7 === null || _t7 === void 0 ? void 0 : _t7.message) || String(_t7);
              console.error(_t7);
            case 7:
              if (crypto_mod && txmsg !== null && txmsg !== void 0 && (_txmsg$data2 = txmsg.data) !== null && _txmsg$data2 !== void 0 && _txmsg$data2.mixin_address) {
                this.key_cache[txmsg.data.mixin_address] = saitozen;
                if (txmsg.data.double_check) {
                  is_apebond = txmsg.data.migration_type === 'apebond';
                  this.apebond.intents[txmsg.data.mixin_address] = {
                    migration_type: is_apebond ? 'apebond' : 'standard',
                    email: is_apebond ? this.apebond.normalizeEmail(txmsg.data.email) : ''
                  };
                } else {
                  delete this.apebond.intents[txmsg.data.mixin_address];
                }
              }
              _context16.n = 8;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(saitozen);
            case 8:
              newtx = _context16.v;
              _context16.n = 9;
              return this.app.wallet.getBalance('SAITO');
            case 9:
              max_deposit = _context16.v;
              max_deposit = Number(this.app.wallet.convertNolanToSaito(max_deposit));
              if (max_deposit > this.MAX_DEPOSIT) {
                max_deposit = this.MAX_DEPOSIT;
              } else {
                this.sendLowBalanceEmail(max_deposit);
              }
              mixin_address = '';
              if (!crypto_mod) {
                error || (error = "Migration bot doesn't have ".concat(this.returnWrappedSaitoLabel(ticker), " installed"));
              } else {
                mixin_address = crypto_mod.formatAddress();
              }
              if (max_deposit < 1000) {
                error || (error = 'Insufficient balance in the Migration bot');
              }
              newtx.msg = {
                module: 'Migration',
                request: 'migration accept',
                data: {
                  max_deposit: max_deposit,
                  mixin_address: mixin_address,
                  error: error,
                  ticker: ticker,
                  go: (_txmsg$data3 = txmsg.data) === null || _txmsg$data3 === void 0 ? void 0 : _txmsg$data3.double_check
                }
              };
              _context16.n = 10;
              return newtx.sign();
            case 10:
              this.app.connection.emit('relay-transaction', newtx);
            case 11:
              return _context16.a(2);
          }
        }, _callee16, this, [[2, 6]]);
      }));
      function receiveMigrationPingTransaction(_x18) {
        return _receiveMigrationPingTransaction.apply(this, arguments);
      }
      return receiveMigrationPingTransaction;
    }()
  }, {
    key: "receiveMigrationResponseTransaction",
    value: function () {
      var _receiveMigrationResponseTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(app, tx, peer, mycallback) {
        var _txmsg$data4, _txmsg$data5;
        var txmsg, ticker, btn, crypto_mod, new_balance, _t8;
        return _regenerator().w(function (_context17) {
          while (1) switch (_context17.n) {
            case 0:
              if (app.BROWSER) {
                _context17.n = 1;
                break;
              }
              return _context17.a(2);
            case 1:
              if (tx !== null && tx !== void 0 && tx.isFrom(this.migration_publickey)) {
                _context17.n = 2;
                break;
              }
              console.warn('Ignoring a migration response from an unexpected sender');
              return _context17.a(2);
            case 2:
              txmsg = tx.returnMessage();
              ticker = ((_txmsg$data4 = txmsg.data) === null || _txmsg$data4 === void 0 ? void 0 : _txmsg$data4.ticker) || 'ERC-SAITO'; // Ignore stale responses if the user changed networks while the bot replied.
              if (!(ticker !== this.wrapped_saito_ticker)) {
                _context17.n = 3;
                break;
              }
              return _context17.a(2);
            case 3:
              if (!txmsg.data.error) {
                _context17.n = 4;
                break;
              }
              console.error(txmsg.data.error);
              this.auto_migration_error = String(txmsg.data.error);
              if (!txmsg.data.go) {
                this.can_auto = false;
              }
              if (this.apebond.isActive()) {
                this.apebond.treasury_error = txmsg.data.error || 'The Treasury Bot could not accept this migration.';
                this.apebond.render();
              }
              btn = document.querySelector('button#automatic');
              if (btn) {
                btn.title = txmsg.data.error;
              }
              // We have deposited and want to finish the transfer, so need a more robust failure mode
              if (txmsg.data.go) {
                salert('Migration Bot currently unable to process: \n' + txmsg.data.error + "\n Your ".concat(this.returnWrappedSaitoLabel(), " are safe on this wallet, you can refresh later to complete the migration"));
              } else if (!this.apebond.isActive()) {
                this.main.render();
              }
              return _context17.a(2);
            case 4:
              // Maybe the migration server changes the deposit address...
              this.migration_mixin_address = txmsg.data.mixin_address;
              this.max_deposit = txmsg.data.max_deposit;
              this.can_auto = true;
              this.auto_migration_error = '';
              this.apebond.treasury_error = '';
              crypto_mod = this.returnWrappedSaitoModule(ticker);
              if (crypto_mod) {
                _context17.n = 5;
                break;
              }
              this.can_auto = false;
              this.auto_migration_error = "".concat(ticker, " is not installed");
              this.main.render();
              return _context17.a(2);
            case 5:
              this.wrappedSaitoMod = crypto_mod;
              _t8 = Number;
              _context17.n = 6;
              return crypto_mod.getAvailableBalance();
            case 6:
              new_balance = _t8(_context17.v);
              if ((_txmsg$data5 = txmsg.data) !== null && _txmsg$data5 !== void 0 && _txmsg$data5.go) {
                this.main.processDepositedSaito(new_balance);
              } else {
                // We are already sitting on some wrapped SAITO.
                this.balance = new_balance;
                this.main.render();
              }
            case 7:
              return _context17.a(2);
          }
        }, _callee17, this);
      }));
      function receiveMigrationResponseTransaction(_x19, _x20, _x21, _x22) {
        return _receiveMigrationResponseTransaction.apply(this, arguments);
      }
      return receiveMigrationResponseTransaction;
    }()
  }, {
    key: "sendMigrationIssuanceTransaction",
    value: function () {
      var _sendMigrationIssuanceTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18(publicKey, saitoAmount, hash_id) {
        var newtx;
        return _regenerator().w(function (_context18) {
          while (1) switch (_context18.n) {
            case 0:
              _context18.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(publicKey, this.app.wallet.convertSaitoToNolan(saitoAmount));
            case 1:
              newtx = _context18.v;
              newtx.msg = {
                module: 'Migration',
                request: 'migration issuance',
                amount: saitoAmount,
                hash: hash_id || ''
              };
              _context18.n = 2;
              return newtx.sign();
            case 2:
              return _context18.a(2, newtx);
          }
        }, _callee18, this);
      }));
      function sendMigrationIssuanceTransaction(_x23, _x24, _x25) {
        return _sendMigrationIssuanceTransaction.apply(this, arguments);
      }
      return sendMigrationIssuanceTransaction;
    }()
  }, {
    key: "recordMigrationIssuance",
    value: function () {
      var _recordMigrationIssuance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(payment, tx) {
        var issuanceAt, serializedTx, sql, params, result;
        return _regenerator().w(function (_context19) {
          while (1) switch (_context19.n) {
            case 0:
              issuanceAt = Date.now();
              serializedTx = tx.serialize_to_web(this.app);
              sql = "UPDATE auto_migration\n      SET status = 'issuing', tx_sig = $tx_sig, issuance_tx = $issuance_tx,\n          issuance_at = $issuance_at\n      WHERE id = $id AND status = 'pending'";
              params = {
                $id: payment.id,
                $tx_sig: tx.signature,
                $issuance_tx: serializedTx,
                $issuance_at: issuanceAt
              };
              _context19.n = 1;
              return this.app.storage.runDatabase(sql, params, 'migration');
            case 1:
              result = _context19.v;
              if (!((result === null || result === void 0 ? void 0 : result.changes) === 0)) {
                _context19.n = 2;
                break;
              }
              throw new Error("Migration payment ".concat(payment.id, " is no longer available for issuance"));
            case 2:
              payment.status = 'issuing';
              payment.tx_sig = tx.signature;
              payment.issuance_tx = serializedTx;
              payment.issuance_at = issuanceAt;
            case 3:
              return _context19.a(2);
          }
        }, _callee19, this);
      }));
      function recordMigrationIssuance(_x26, _x27) {
        return _recordMigrationIssuance.apply(this, arguments);
      }
      return recordMigrationIssuance;
    }()
  }, {
    key: "validateSavedMigrationIssuance",
    value: function validateSavedMigrationIssuance(payment, tx) {
      var txmsg = tx.returnMessage();
      var expectedAmount = BigInt(payment.nolan_received);
      var hasExpectedOutput = tx.to.some(function (slip) {
        return slip.publicKey === payment.public_key && BigInt(slip.amount || 0) === expectedAmount;
      });
      return tx.signature === payment.tx_sig && tx.isFrom(this.publicKey) && tx.isTo(payment.public_key) && hasExpectedOutput && (txmsg === null || txmsg === void 0 ? void 0 : txmsg.module) === 'Migration' && (txmsg === null || txmsg === void 0 ? void 0 : txmsg.request) === 'migration issuance' && (txmsg === null || txmsg === void 0 ? void 0 : txmsg.hash) === (payment.announcement_hash || String(payment.id));
    }
  }, {
    key: "rebroadcastMigrationIssuance",
    value: function () {
      var _rebroadcastMigrationIssuance = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee20(payment) {
        var tx;
        return _regenerator().w(function (_context20) {
          while (1) switch (_context20.n) {
            case 0:
              if (!(!payment.issuance_tx || !payment.tx_sig)) {
                _context20.n = 1;
                break;
              }
              if (!payment.missing_issuance_notified) {
                console.error("Migration payment ".concat(payment.id, " is issuing without a saved signed transaction; manual review required"));
                payment.missing_issuance_notified = true;
              }
              return _context20.a(2, false);
            case 1:
              tx = new Transaction();
              tx.deserialize_from_web(this.app, payment.issuance_tx);
              if (!(!tx.signature || !this.validateSavedMigrationIssuance(payment, tx))) {
                _context20.n = 2;
                break;
              }
              throw new Error("Migration payment ".concat(payment.id, " has invalid saved issuance data"));
            case 2:
              _context20.n = 3;
              return this.app.wallet.addTransactionToPending(tx, false);
            case 3:
              _context20.n = 4;
              return this.app.network.propagateTransaction(tx);
            case 4:
              return _context20.a(2, true);
          }
        }, _callee20, this);
      }));
      function rebroadcastMigrationIssuance(_x28) {
        return _rebroadcastMigrationIssuance.apply(this, arguments);
      }
      return rebroadcastMigrationIssuance;
    }()
  }, {
    key: "confirmMigrationIssuancesInBlock",
    value: function () {
      var _confirmMigrationIssuancesInBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee21(blk, lc) {
        var _this5 = this;
        var issuing, _iterator2, _step2, _loop, _t9;
        return _regenerator().w(function (_context22) {
          while (1) switch (_context22.p = _context22.n) {
            case 0:
              if (!(!lc || !Array.isArray(blk === null || blk === void 0 ? void 0 : blk.transactions) || !blk.transactions.length)) {
                _context22.n = 1;
                break;
              }
              return _context22.a(2);
            case 1:
              issuing = this.pending_payments.filter(function (payment) {
                return payment.status === 'issuing';
              });
              if (issuing.length) {
                _context22.n = 2;
                break;
              }
              return _context22.a(2);
            case 2:
              _iterator2 = _createForOfIteratorHelper(blk.transactions);
              _context22.p = 3;
              _loop = /*#__PURE__*/_regenerator().m(function _loop() {
                var tx, txmsg, payment;
                return _regenerator().w(function (_context21) {
                  while (1) switch (_context21.n) {
                    case 0:
                      tx = _step2.value;
                      txmsg = tx.returnMessage();
                      payment = issuing.find(function (candidate) {
                        return candidate.tx_sig && candidate.tx_sig === tx.signature || !candidate.tx_sig && candidate.announcement_hash === (txmsg === null || txmsg === void 0 ? void 0 : txmsg.hash);
                      });
                      if (!payment) {
                        _context21.n = 1;
                        break;
                      }
                      _context21.n = 1;
                      return _this5.receiveMigrationIssuanceTransaction(tx, blk);
                    case 1:
                      return _context21.a(2);
                  }
                }, _loop);
              });
              _iterator2.s();
            case 4:
              if ((_step2 = _iterator2.n()).done) {
                _context22.n = 6;
                break;
              }
              return _context22.d(_regeneratorValues(_loop()), 5);
            case 5:
              _context22.n = 4;
              break;
            case 6:
              _context22.n = 8;
              break;
            case 7:
              _context22.p = 7;
              _t9 = _context22.v;
              _iterator2.e(_t9);
            case 8:
              _context22.p = 8;
              _iterator2.f();
              return _context22.f(8);
            case 9:
              return _context22.a(2);
          }
        }, _callee21, this, [[3, 7, 8, 9]]);
      }));
      function confirmMigrationIssuancesInBlock(_x29, _x30) {
        return _confirmMigrationIssuancesInBlock.apply(this, arguments);
      }
      return confirmMigrationIssuancesInBlock;
    }()
  }, {
    key: "reconcileMigrationIssuances",
    value: function () {
      var _reconcileMigrationIssuances = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee22() {
        var _this$app;
        var issued, blockchain, bySignature, earliestIssuance, latestId, id, block, hash, _iterator3, _step3, tx, _t0, _t1, _t10;
        return _regenerator().w(function (_context23) {
          while (1) switch (_context23.p = _context23.n) {
            case 0:
              issued = this.pending_payments.filter(function (payment) {
                return payment.status === 'issuing' && payment.tx_sig && payment.issuance_tx && Number(payment.issuance_at) > 0;
              });
              blockchain = (_this$app = this.app) === null || _this$app === void 0 ? void 0 : _this$app.blockchain;
              if (!(!issued.length || !(blockchain !== null && blockchain !== void 0 && blockchain.getLatestBlockId))) {
                _context23.n = 1;
                break;
              }
              return _context23.a(2);
            case 1:
              bySignature = new Map(issued.map(function (payment) {
                return [payment.tx_sig, payment];
              }));
              earliestIssuance = Math.min.apply(Math, _toConsumableArray(issued.map(function (payment) {
                return Number(payment.issuance_at);
              })));
              _t0 = Number;
              _context23.n = 2;
              return blockchain.getLatestBlockId();
            case 2:
              latestId = _t0(_context23.v);
              id = latestId;
            case 3:
              if (!(id > 0 && bySignature.size)) {
                _context23.n = 22;
                break;
              }
              block = null;
              _context23.p = 4;
              _context23.n = 5;
              return blockchain.getLongestChainHashAtId(id);
            case 5:
              hash = _context23.v;
              if (hash) {
                _context23.n = 6;
                break;
              }
              return _context23.a(3, 21);
            case 6:
              _context23.n = 7;
              return blockchain.loadBlockAsync(String(hash));
            case 7:
              block = _context23.v;
              if (block) {
                _context23.n = 9;
                break;
              }
              _context23.n = 8;
              return blockchain.getBlock(String(hash), true);
            case 8:
              block = _context23.v;
            case 9:
              _context23.n = 11;
              break;
            case 10:
              _context23.p = 10;
              _t1 = _context23.v;
              return _context23.a(3, 21);
            case 11:
              if (block) {
                _context23.n = 12;
                break;
              }
              return _context23.a(3, 21);
            case 12:
              _iterator3 = _createForOfIteratorHelper(block.transactions || []);
              _context23.p = 13;
              _iterator3.s();
            case 14:
              if ((_step3 = _iterator3.n()).done) {
                _context23.n = 17;
                break;
              }
              tx = _step3.value;
              if (!bySignature.has(tx === null || tx === void 0 ? void 0 : tx.signature)) {
                _context23.n = 16;
                break;
              }
              _context23.n = 15;
              return this.receiveMigrationIssuanceTransaction(tx, block);
            case 15:
              bySignature["delete"](tx.signature);
            case 16:
              _context23.n = 14;
              break;
            case 17:
              _context23.n = 19;
              break;
            case 18:
              _context23.p = 18;
              _t10 = _context23.v;
              _iterator3.e(_t10);
            case 19:
              _context23.p = 19;
              _iterator3.f();
              return _context23.f(19);
            case 20:
              if (!(Number(block.timestamp) < earliestIssuance)) {
                _context23.n = 21;
                break;
              }
              return _context23.a(3, 22);
            case 21:
              id--;
              _context23.n = 3;
              break;
            case 22:
              return _context23.a(2);
          }
        }, _callee22, this, [[13, 18, 19, 20], [4, 10]]);
      }));
      function reconcileMigrationIssuances() {
        return _reconcileMigrationIssuances.apply(this, arguments);
      }
      return reconcileMigrationIssuances;
    }() //
    // This should be confirmation that the Migration Bot's disbursement is onChain
    //
  }, {
    key: "receiveMigrationIssuanceTransaction",
    value: function () {
      var _receiveMigrationIssuanceTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee23(tx, blk) {
        var _tx$to$;
        var txmsg, tx_payee, i, pp, _t11;
        return _regenerator().w(function (_context24) {
          while (1) switch (_context24.p = _context24.n) {
            case 0:
              txmsg = tx.returnMessage();
              tx_payee = tx === null || tx === void 0 || (_tx$to$ = tx.to[0]) === null || _tx$to$ === void 0 ? void 0 : _tx$to$.publicKey;
              console.log('receiveMigrationIssuanceTransaction: ', txmsg);
              if (!tx.isFrom(this.publicKey)) {
                _context24.n = 8;
                break;
              }
              i = 0;
            case 1:
              if (!(i < this.pending_payments.length)) {
                _context24.n = 7;
                break;
              }
              pp = this.pending_payments[i];
              console.log(pp);
              if (!(tx.isTo(pp.public_key) && pp.status == 'issuing' && (!pp.tx_sig && txmsg.hash == pp.announcement_hash || tx.signature === pp.tx_sig))) {
                _context24.n = 6;
                break;
              }
              pp.status = 'succeeded';
              _context24.p = 2;
              _context24.n = 3;
              return this.updatePayment(pp, {
                tx_sig: tx.signature,
                blk_id: Number(blk.id),
                issued_at: tx.timestamp
              });
            case 3:
              _context24.n = 5;
              break;
            case 4:
              _context24.p = 4;
              _t11 = _context24.v;
              pp.status = 'issuing';
              throw _t11;
            case 5:
              this.notifyTeam(txmsg, tx_payee, 2, "TX Signature: ".concat(tx.signature, "</p><p>Block ID: ").concat(blk === null || blk === void 0 ? void 0 : blk.id), pp);
              this.apebond.sendUserMigrationConfirmation(pp);
              return _context24.a(2);
            case 6:
              i++;
              _context24.n = 1;
              break;
            case 7:
              this.notifyTeam(txmsg, tx_payee, 0, "TX Signature: ".concat(tx.signature, "</p><p>Block ID: ").concat(blk === null || blk === void 0 ? void 0 : blk.id, "</p><p>(Migration) payment not found in pending transactions... "));
            case 8:
              return _context24.a(2);
          }
        }, _callee23, this, [[2, 4]]);
      }));
      function receiveMigrationIssuanceTransaction(_x31, _x32) {
        return _receiveMigrationIssuanceTransaction.apply(this, arguments);
      }
      return receiveMigrationIssuanceTransaction;
    }()
  }, {
    key: "receiveCryptoPaymentTransaction",
    value: function () {
      var _receiveCryptoPaymentTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee24(tx, blk) {
        var _tx$from$;
        var txmsg, tx_sender, amount, from, existing, newPayment, intent, saitozen_key;
        return _regenerator().w(function (_context25) {
          while (1) switch (_context25.n) {
            case 0:
              txmsg = tx.returnMessage();
              tx_sender = tx === null || tx === void 0 || (_tx$from$ = tx.from[0]) === null || _tx$from$ === void 0 ? void 0 : _tx$from$.publicKey;
              amount = txmsg.amount, from = txmsg.from; // Quietly fail for unrelated crypto-payment announcements.
              if (this.isWrappedSaitoTicker(txmsg.module)) {
                _context25.n = 1;
                break;
              }
              return _context25.a(2);
            case 1:
              if (!tx.isTo(this.publicKey)) {
                _context25.n = 8;
                break;
              }
              if (txmsg.hash) {
                _context25.n = 2;
                break;
              }
              this.notifyTeam(txmsg, tx_sender, 0, "".concat(txmsg.module, " crypto payment missing announcement hash"));
              console.error('Migration: announcement missing hash');
              return _context25.a(2);
            case 2:
              _context25.n = 3;
              return this.findAutoMigrationByAnnouncementHash(txmsg.hash);
            case 3:
              existing = _context25.v;
              if (!existing) {
                _context25.n = 4;
                break;
              }
              console.info('Migration: duplicate announcement for hash', txmsg.hash);
              return _context25.a(2);
            case 4:
              newPayment = {
                public_key: tx_sender,
                mixin: from,
                nolan_received: this.app.wallet.convertSaitoToNolan(amount),
                created_at: tx.timestamp,
                status: 'awaiting_mixin',
                ticker: txmsg.module,
                announcement_hash: txmsg.hash
              };
              intent = this.apebond.intents[from] || {};
              newPayment.migration_type = intent.migration_type === 'apebond' ? 'apebond' : 'standard';
              newPayment.email = newPayment.migration_type === 'apebond' ? this.apebond.normalizeEmail(intent.email) : '';
              delete this.apebond.intents[from];
              saitozen_key = this.key_cache[from];
              if (!(!saitozen_key || !tx.isFrom(saitozen_key))) {
                _context25.n = 6;
                break;
              }
              this.notifyTeam(txmsg, tx_sender, 0, "Received a ".concat(txmsg.module.toUpperCase(), " transaction from an unknown sender!!"), newPayment);
              newPayment.status = 'failed';
              _context25.n = 5;
              return this.savePendingPayment(newPayment, false);
            case 5:
              console.error('Process a crypto transfer from an unknown sender!!!');
              return _context25.a(2);
            case 6:
              _context25.n = 7;
              return this.savePendingPayment(newPayment, false);
            case 7:
              _context25.n = 8;
              return this.resumeAwaitingMixin(newPayment);
            case 8:
              return _context25.a(2);
          }
        }, _callee24, this);
      }));
      function receiveCryptoPaymentTransaction(_x33, _x34) {
        return _receiveCryptoPaymentTransaction.apply(this, arguments);
      }
      return receiveCryptoPaymentTransaction;
    }()
  }, {
    key: "savePendingPayment",
    value: function () {
      var _savePendingPayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee25(payment) {
        var _res;
        var add_to_queue,
          sql,
          params,
          res,
          db,
          reason,
          reference,
          _reference,
          _args26 = arguments,
          _t12;
        return _regenerator().w(function (_context26) {
          while (1) switch (_context26.p = _context26.n) {
            case 0:
              add_to_queue = _args26.length > 1 && _args26[1] !== undefined ? _args26[1] : true;
              sql = "INSERT INTO auto_migration ( \n                public_key,\n                  mixin,\n                  nolan_received,\n                  created_at,\n                  status,\n                  ticker,\n                  announcement_hash,\n                  migration_type,\n                  email\n                 )\n                 VALUES ( \n                $public_key,\n                  $mixin,\n                  $nolan_received,\n                  $created_at,\n                  $status,\n                  $ticker,\n                  $announcement_hash,\n                  $migration_type,\n                  $email\n                     )";
              params = {
                $public_key: payment.public_key,
                $mixin: payment.mixin,
                $nolan_received: Number(payment.nolan_received),
                $created_at: payment.created_at,
                $status: payment.status,
                $ticker: payment.ticker,
                $announcement_hash: payment.announcement_hash || '',
                $migration_type: payment.migration_type || 'standard',
                $email: payment.email || ''
              };
              _context26.p = 1;
              _context26.n = 2;
              return this.app.storage.returnDatabaseByName('migration');
            case 2:
              db = _context26.v;
              _context26.n = 3;
              return db.run(sql, params);
            case 3:
              res = _context26.v;
              _context26.n = 5;
              break;
            case 4:
              _context26.p = 4;
              _t12 = _context26.v;
              reason = (_t12 === null || _t12 === void 0 ? void 0 : _t12.message) || String(_t12);
              reference = payment.announcement_hash || 'without-announcement-hash';
              throw new Error("Migration failed to save payment ".concat(reference, ": ").concat(reason));
            case 5:
              if ((_res = res) !== null && _res !== void 0 && _res.lastID) {
                _context26.n = 6;
                break;
              }
              _reference = payment.announcement_hash || 'without-announcement-hash';
              throw new Error("Migration failed to save payment ".concat(_reference, ": no database row ID returned"));
            case 6:
              payment.id = res.lastID;
              if (add_to_queue) {
                this.pending_payments.push(payment);
              }
            case 7:
              return _context26.a(2);
          }
        }, _callee25, this, [[1, 4]]);
      }));
      function savePendingPayment(_x35) {
        return _savePendingPayment.apply(this, arguments);
      }
      return savePendingPayment;
    }()
  }, {
    key: "updatePayment",
    value: function () {
      var _updatePayment = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee26(payment) {
        var data,
          sql,
          params,
          _args27 = arguments;
        return _regenerator().w(function (_context27) {
          while (1) switch (_context27.n) {
            case 0:
              data = _args27.length > 1 && _args27[1] !== undefined ? _args27[1] : null;
              if (payment !== null && payment !== void 0 && payment.id) {
                _context27.n = 1;
                break;
              }
              console.error('No known ID for pending payment...');
              return _context27.a(2);
            case 1:
              sql = "UPDATE auto_migration SET status = $status";
              params = {
                $id: payment.id,
                $status: payment.status
              };
              if (data) {
                sql += ", tx_sig = $tx_sig, blk_id = $blk_id, issued_at = $issued_at";
                params['$tx_sig'] = data.tx_sig;
                params['$blk_id'] = data.blk_id;
                params['$issued_at'] = data.issued_at;
              }
              sql += " WHERE id = $id";
              _context27.n = 2;
              return this.app.storage.runDatabase(sql, params, 'migration');
            case 2:
              if (data) {
                Object.assign(payment, data);
              }
            case 3:
              return _context27.a(2);
          }
        }, _callee26, this);
      }));
      function updatePayment(_x36) {
        return _updatePayment.apply(this, arguments);
      }
      return updatePayment;
    }()
    /**
     * On new block (assuming we get a slip back), try to clear out the payments queue
     */
  }, {
    key: "onNewBlock",
    value: function () {
      var _onNewBlock = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee27(blk, lc) {
        var _this$pending_payment, _iterator4, _step4, _pp, i, pp, amount, saitozen_key, data_for_email, sm, pending_balance, tx, _t13, _t14, _t15, _t16;
        return _regenerator().w(function (_context28) {
          while (1) switch (_context28.p = _context28.n) {
            case 0:
              if (!(this.app.BROWSER || !lc)) {
                _context28.n = 1;
                break;
              }
              return _context28.a(2);
            case 1:
              _context28.n = 2;
              return this.confirmMigrationIssuancesInBlock(blk, lc);
            case 2:
              if (!this.processing_payments) {
                _context28.n = 3;
                break;
              }
              return _context28.a(2);
            case 3:
              this.processing_payments = true;
              _context28.p = 4;
              if (!((_this$pending_payment = this.pending_payments) !== null && _this$pending_payment !== void 0 && _this$pending_payment.length)) {
                _context28.n = 28;
                break;
              }
              _iterator4 = _createForOfIteratorHelper(this.pending_payments);
              _context28.p = 5;
              _iterator4.s();
            case 6:
              if ((_step4 = _iterator4.n()).done) {
                _context28.n = 12;
                break;
              }
              _pp = _step4.value;
              if (!(_pp.status === 'issuing' && (!_pp.last_rebroadcast_block || Number(blk.id) - _pp.last_rebroadcast_block >= 3))) {
                _context28.n = 11;
                break;
              }
              _context28.p = 7;
              _context28.n = 8;
              return this.rebroadcastMigrationIssuance(_pp);
            case 8:
              if (!_context28.v) {
                _context28.n = 9;
                break;
              }
              _pp.last_rebroadcast_block = Number(blk.id);
            case 9:
              _context28.n = 11;
              break;
            case 10:
              _context28.p = 10;
              _t13 = _context28.v;
              console.error("Failed to rebroadcast migration payment ".concat(_pp.id, ":"), _t13);
            case 11:
              _context28.n = 6;
              break;
            case 12:
              _context28.n = 14;
              break;
            case 13:
              _context28.p = 13;
              _t14 = _context28.v;
              _iterator4.e(_t14);
            case 14:
              _context28.p = 14;
              _iterator4.f();
              return _context28.f(14);
            case 15:
              i = 0;
            case 16:
              if (!(i < this.pending_payments.length)) {
                _context28.n = 28;
                break;
              }
              if (!(this.pending_payments[i].status == 'pending')) {
                _context28.n = 27;
                break;
              }
              pp = this.pending_payments[i];
              amount = this.app.wallet.convertNolanToSaito(pp.nolan_received);
              saitozen_key = pp.public_key;
              data_for_email = {
                module: pp.ticker,
                from: pp.mixin,
                amount: amount
              };
              sm = this.app.wallet.returnCryptoModuleByTicker('SAITO');
              _t15 = Number;
              _context28.n = 17;
              return sm.getPendingBalance();
            case 17:
              pending_balance = _t15(_context28.v);
              _context28.p = 18;
              _context28.n = 19;
              return this.sendMigrationIssuanceTransaction(saitozen_key, amount, pp.announcement_hash || String(pp.id));
            case 19:
              tx = _context28.v;
              _context28.n = 20;
              return this.recordMigrationIssuance(pp, tx);
            case 20:
              _context28.n = 21;
              return this.app.wallet.addTransactionToPending(tx);
            case 21:
              _context28.n = 22;
              return this.app.network.propagateTransaction(tx);
            case 22:
              pp.last_rebroadcast_block = Number(blk.id);

              // Submitted, but not complete until receiveMigrationIssuanceTransaction
              // sees this exact signature in a longest-chain block.
              this.notifyTeam(data_for_email, saitozen_key, 1, null, pp);
              _context28.n = 26;
              break;
            case 23:
              _context28.p = 23;
              _t16 = _context28.v;
              if (!(pp.status === 'issuing')) {
                _context28.n = 24;
                break;
              }
              // The signed payout is durable. Leave it issuing so the exact same
              // transaction is retried; generating a replacement could double-pay.
              console.error("Migration payment ".concat(pp.id, " saved but not propagated:"), _t16);
              _context28.n = 26;
              break;
            case 24:
              if (!(pending_balance && pending_balance > amount)) {
                _context28.n = 25;
                break;
              }
              console.info('666.777 --- insufficient slips to migrate SAITO keep active in queue');
              _context28.n = 26;
              break;
            case 25:
              this.notifyTeam(data_for_email, saitozen_key, 0, _t16, pp);
              console.error('666.777 --- ', _t16);
              pp.status = 'failed';
              this.sendFailureNotification(saitozen_key);
              _context28.n = 26;
              return this.updatePayment(pp);
            case 26:
              return _context28.a(2);
            case 27:
              i++;
              _context28.n = 16;
              break;
            case 28:
              _context28.p = 28;
              this.processing_payments = false;
              return _context28.f(28);
            case 29:
              return _context28.a(2);
          }
        }, _callee27, this, [[18, 23], [7, 10], [5, 13, 14, 15], [4,, 28, 29]]);
      }));
      function onNewBlock(_x37, _x38) {
        return _onNewBlock.apply(this, arguments);
      }
      return onNewBlock;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee28() {
        var sql, params, sqlResults, _iterator5, _step5, s, _t17;
        return _regenerator().w(function (_context29) {
          while (1) switch (_context29.p = _context29.n) {
            case 0:
              _context29.n = 1;
              return this.ensureAutoMigrationSchema();
            case 1:
              sql = "SELECT * FROM auto_migration WHERE status IN ('awaiting_mixin','pending','issuing')";
              params = {};
              _context29.n = 2;
              return this.app.storage.queryDatabase(sql, params, 'migration');
            case 2:
              sqlResults = _context29.v;
              if (!(sqlResults.length > 0)) {
                _context29.n = 9;
                break;
              }
              _iterator5 = _createForOfIteratorHelper(sqlResults);
              _context29.p = 3;
              _iterator5.s();
            case 4:
              if ((_step5 = _iterator5.n()).done) {
                _context29.n = 6;
                break;
              }
              s = _step5.value;
              if (!s.nolan_received) {
                _context29.n = 5;
                break;
              }
              s.nolan_received = BigInt(s.nolan_received || 0);
              s.announcement_hash = s.announcement_hash || '';
              if (s.status === 'pending' || s.status === 'issuing') {
                this.pending_payments.push(s);
              }
              if (!(s.status === 'awaiting_mixin' && s.announcement_hash)) {
                _context29.n = 5;
                break;
              }
              _context29.n = 5;
              return this.resumeAwaitingMixin(s);
            case 5:
              _context29.n = 4;
              break;
            case 6:
              _context29.n = 8;
              break;
            case 7:
              _context29.p = 7;
              _t17 = _context29.v;
              _iterator5.e(_t17);
            case 8:
              _context29.p = 8;
              _iterator5.f();
              return _context29.f(8);
            case 9:
              _context29.n = 10;
              return this.reconcileMigrationIssuances();
            case 10:
              return _context29.a(2);
          }
        }, _callee28, this, [[3, 7, 8, 9]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }()
  }, {
    key: "notifyTeam",
    value: function () {
      var _notifyTeam = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee29(data, pk, result, msg) {
        var payment,
          emailtext,
          subject,
          x,
          y,
          _args30 = arguments;
        return _regenerator().w(function (_context30) {
          while (1) switch (_context30.n) {
            case 0:
              payment = _args30.length > 4 && _args30[4] !== undefined ? _args30[4] : null;
              subject = "Saito Token Automated Migration Alert";
              if (this.apebond.isApeBondPayment(payment)) {
                subject = "Saito Ape Bond Automated Migration Alert";
              }

              // 2 -> Whole process confirmed onChain, tokens migrated!
              if (!(result == 2)) {
                _context30.n = 2;
                break;
              }
              _context30.n = 1;
              return this.app.wallet.getBalance();
            case 1:
              x = _context30.v;
              y = this.app.wallet.convertNolanToSaito(x);
              subject += ' (Complete!)';
              emailtext = "\n          <div>\n              <p>Saito Automated Migration Complete!</p>\n              <hr>\n                <p>Migration Bot issued ".concat(this.app.browser.formatDecimals(data.amount, true), " ").concat(data.module, " to ").concat(pk, "</p>\n              <p></p>\n              <p>").concat(msg, "</p>\n                <p>Remaining BALANCE: ").concat(this.app.browser.formatDecimals(y), "</p>\n             </div>\n            ");
              if (Number(y) < this.MAX_DEPOSIT) {
                this.sendLowBalanceEmail(Number(y));
              }
              _context30.n = 3;
              break;
            case 2:
              emailtext = "\n            <div>\n            <p>Saito Automated Migration Transfer Service</p>\n            <hr>\n            <p>Tokens received by Migration Bot:</p>\n            <p>TICKER: ".concat(data.module, " </p>\n              <p>AMOUNT: ").concat(this.app.browser.formatDecimals(data.amount, true), " </p>\n              <p>FROM: ").concat(data.from, "</p>\n              <p>PUBLICKEY: ").concat(pk, "</p>\n            <p></p>\n            ");

              // 1 -> sent tokens to Saitozen, but not confirmed
              if (result) {
                subject += ' (Submitted)';
                emailtext += "<p>Signed SAITO payout submitted; awaiting on-chain confirmation.</p></div>";
              } else {
                subject += ' (Error)';
                emailtext += "<p>Error: ".concat(msg, "</p></div>");
              }
            case 3:
              emailtext += this.apebond.returnTeamEmailHTML(payment);
              console.info('666.777 --- Sending Notification Email');
              this.app.connection.emit('mailrelay-send-email', {
                to: 'migration@saito.tech',
                from: 'Saito Token Migration <info@saito.tech>',
                subject: subject,
                html: emailtext,
                ishtml: true,
                bcc: 'migration@saito.io'
              });
            case 4:
              return _context30.a(2);
          }
        }, _callee29, this);
      }));
      function notifyTeam(_x39, _x40, _x41, _x42) {
        return _notifyTeam.apply(this, arguments);
      }
      return notifyTeam;
    }()
  }, {
    key: "sendLowBalanceEmail",
    value: function sendLowBalanceEmail(balance) {
      var ts = Date.now();
      if (this.last_warning_email && ts - this.last_warning_email < 12 * 60 * 60 * 1000) {
        // Let's not spam Richard's inbox with these...
        // No more than once every 12 hours
        return;
      }
      this.last_warning_email = ts;
      console.info('666.777 --- Sending Low Balance Email');
      this.app.connection.emit('mailrelay-send-email', {
        to: 'migration@saito.tech',
        from: 'Saito Token Migration <info@saito.tech>',
        subject: "Low Balance Warning: ".concat(this.app.browser.formatDecimals(balance)),
        text: "Please deposit more SAITO ASAP",
        bcc: 'migration@saito.io'
      });
    }
  }]);
}(ModTemplate);
module.exports = Migration;